export enum UserDefinedFieldPosition {
	employeeInfoLeft = 1,
	employeeInfoRight = 2
}